<div class="w-[1200px]">
  <h2 class="font-semibold text-lg mb-4">{{ title$ | async }}</h2>
  <div class="flex gap-x-2 mb-2">
    <app-autocomplete
      class="w-1/2"
      [formControl]="buyerForm.controls.clientId"
      [items]="(clients$ | async)!"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Мой клиент"
      [labelOutside]="false"
    ></app-autocomplete>
    <app-autocomplete
      class="w-1/2"
      [formControl]="buyerForm.controls.farmId"
      [items]="(farms$ | async)!"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Питомник"
      [labelOutside]="false"
    ></app-autocomplete>
  </div>
  <div class="flex gap-x-2">
    <tui-input
      class="w-4/12"
      tuiTextfieldSize="m"
      [formControl]="buyerForm.controls.code"
      >Код клиента питомника</tui-input
    >
    <tui-input
      class="w-4/12"
      tuiTextfieldSize="m"
      [formControl]="buyerForm.controls.name"
      >Наименование</tui-input
    >
  </div>
  <div class="flex justify-between mt-4">
    <div class="w-2/12 flex gap-x-2 items-center">
      <app-checkbox
        [formControl]="buyerForm.controls.publicAccess"
      ></app-checkbox>
      Публичный доступ
    </div>
    <div>
      <button
        (click)="context.$implicit.complete()"
        size="m"
        appearance="outline"
        tuiButton
        class="mr-2"
      >
        Отмена
      </button>
      <button
        (click)="save$.next()"
        [disabled]="!buyerForm.valid"
        tuiButton
        size="m"
      >
        Сохранить
      </button>
    </div>
  </div>
</div>
